import { LuSearch, LuChevronDown } from "@/Components/Icons/Icons.jsx";

export default {
  row1: [
    {
      column: "column1",
      columnWidth: "45%",

      rows: {
        row1: [
          {
            name: "customerAddressType",
            label: "Type",
            component: "dropdown",
            endIconName: LuChevronDown,
            iconColor: "gray-400",
            options: [
              { label: "Delivery", value: "Delivery" },
              { label: "Factory", value: "Factory" },
              { label: "Pickup", value: "Pickup" },
              { label: "Warehouse", value: "Warehouse" },
            ],
          },
        ],
        row2: [
          {
            name: "customerName",
            label: "Name",
            component: "text-field",
          },
        ],
        row3: [
          {
            name: "customerCity",
            label: "City",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getCityMaster",
            // dependsOn: "state",
            // useLinkedValue : "state"
          },
        ],
        row4: [
          {
            name: "customerPostalCode",
            label: "Postal Code",
            component: "text-field",
          },
        ],
        row5: [
          {
            name: "exporterAddress",
            actionText: "Address",
            component: "textarea",
            width: "100%",
            height: 100,
          },
        ],
      },
    },
    {
      column: "column2",
      columnWidth: "45%",

      rows: {
        row1: [
          {
            name: "Init",
            label: "Init.BranchDetails",
            component: "backlink",
            action: "openPackageModal",
            sx: {
              mt: 5,
            },
          },
        ],
        row2: [
          {
            name: "customerState",
            label: "State/Province",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getStateMaster",
          },
        ],
        row3: [
          {
            name: "customerTelephone",
            label: "Telephone",
            component: "text-field",
          },
        ],
        row4: [
          {
            name: "customerFax",
            label: "Fax",
            component: "text-field",
          },
        ],
        row5: [
          {
            name: "customerEmailAddress",
            label: "Email",
            component: "text-field",
          },
        ],
      },
    },
  ],
};
